if (!window.tabsTiendasMapListenerAttached) {
  window.tabsTiendasMapListenerAttached = true;

  function openMapModal(modal, src, title) {
    if (!modal || !src) return;

    const iframe = modal.querySelector('[data-map-modal-iframe]');
    const titleEl = modal.querySelector('[data-map-modal-title]');

    if (iframe) iframe.setAttribute('src', src);
    if (titleEl) titleEl.textContent = title || '';

    modal.classList.add('modal-map--active');
    document.body.classList.add('modal-map-open');
  }

  function closeMapModal(modal) {
    if (!modal) return;

    const iframe = modal.querySelector('[data-map-modal-iframe]');
    if (iframe) iframe.setAttribute('src', '');

    modal.classList.remove('modal-map--active');
    document.body.classList.remove('modal-map-open');
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-map-trigger]');
    if (trigger) {
      event.preventDefault();
      const section = trigger.closest('[data-section-type="tabs-tiendas"]');
      const modal = section && section.querySelector('[data-map-modal]');
      openMapModal(modal, trigger.getAttribute('data-map-src'), trigger.getAttribute('data-map-title'));
      return;
    }

    const closeTrigger = event.target.closest('[data-map-modal-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeMapModal(closeTrigger.closest('[data-map-modal]'));
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.modal-map--active').forEach(closeMapModal);
  });
}
